import * as React from "react";

interface IProps {
	onCsvDrop: (
		e: React.DragEvent<HTMLDivElement>,
		acceptedFiles: FileList
	) => void;
}

const FileDropBox: React.FC<IProps> = (props: IProps) => {
	const [highlighted, setHighlighted] = React.useState(false);
	const styles = {
		margin: "auto",
		padding: "20px",
		border: "3px dotted #ccc",
		marginBottom: "20px",
	};

	return (
		<div
			className={`${highlighted ? "border-secondary" : ""}`}
			style={styles}
			onDragOver={(e) => {
				e.preventDefault();
				setHighlighted(true);
			}}
			onDragLeave={() => {
				setHighlighted(false);
			}}
			onDrop={(e) => {
				e.preventDefault();
				setHighlighted(false);
				const files = e.dataTransfer.files;
				props.onCsvDrop(e, files);
			}}
		>
			<h2 className="text-center">Drop CSV File Here</h2>
		</div>
	);
};

export default FileDropBox;
